export default __webpack_public_path__ + "static/media/7-19_G.38c7f84d.svg";